import { useContext } from 'react';

// Components
import { Context } from '@/components/Store';
// Modules
import { setInnerHTML } from '@/lib/util';

const ProductPrice = () => {
	const [state] = useContext(Context);

	return state?.pricingText?.length ? (
		<p
			className="price"
			dangerouslySetInnerHTML={setInnerHTML(state.pricingText)}
		></p>
	) : null;
};

export { ProductPrice };
